export enum GAIds {
  DEV = 'UA-99713149-3',
  QA = 'UA-99713149-2',
  UA = 'UA-99713149-2',
  PROD = 'UA-99713149-1'
}
